module.exports = __webpack_public_path__ + "assets/img/benefit-7.58d50192.svg";